import React from 'react';
import { Deck, Slayt, Metrik, MetrikSira, Tablo, Not, Dagilim, GrupSeridi, tl } from './EylulSlaytKit';

/**
 * HUPALUPA Eğlence — Eylül 2026 medya planı. ÜÇ slayt.
 *
 * 🔑 Bu markanın önerisi bir AZALTMA: Ağustos ₺286.044 → ₺250.000 (−%12,6).
 *    Sebep uydurma değil ölçülü: eğlence merkezi kategorisinde talep Eylül'de
 *    iki yıl üst üste −%33. Okul açılıyor, hafta içi gündüz trafiği bitiyor.
 *    Serbest kalan bütçe Kixx'e aktarılıyor (bkz. GrupSeridi).
 *
 * 🔴 Marka mağaza DEĞİL, eğlence merkezi — [[project_hupalupa_lokasyon_rontgeni]].
 * 🔴 KPI ciro değil BAŞLAYAN SOHBET. Bu hesapta ciro sütunu yanlış olur.
 *
 * Kaynak: Keyword Planner (geo TR 2792, GOOGLE_SEARCH, çekim 31 Ağu 2026) +
 * /api/group/hupalupa/monthly (canlı Meta act_1492081179012995, Google 6717327296,
 * TikTok 7604848080818683921).
 * ⚠️ Ağustos rakamları 31 Ağu 14:29 (TR) itibarıyla; ayın son yarım günü eksik.
 */

export default function HupalupaEglenceEylul2026() {
  return (
    <Deck
      marka="HUPALUPA Eğlence"
      altBaslik="Eğlence merkezi · hupalupa.com.tr · KPI: başlayan sohbet · Meta + Google + TikTok"
      logo="/logos/grup/hupalupa-eglence.png"
      logoBg="bg-white border border-gray-200"
      butce={250000}
      oncekiButce={286044}
    >
      {/* ════════════ SLAYT 1 — TALEP ════════════ */}
      <Slayt
        no={1}
        etiket="Slayt 1 · Talep"
        accent="#B45309"
        baslik="Eylül, eğlence merkezinin yılın en sert daralma ayı."
        spot="Okul açılıyor ve hafta içi gündüz trafiği bitiyor. Kategori sorgularının tamamı geriliyor — tek istisna doğum günü. Bu ay için dürüst öneri bütçeyi büyütmek değil, küçültüp kalanı doğru güne ve doğru mesaja yığmak."
        dipnot="Kaynak: Google Ads Keyword Planner, geo Türkiye, dil Türkçe, yalnızca Google Arama. Planner değerleri sabit bucket'lardan gelir; −%33 ve −%18 iki komşu bucket arasındaki adımdır."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="&quot;eğlence merkezi&quot; Eylül" deger="−%33" alt="49.500 → 33.100 · 2024'te de −%33" ton="kotu" />
          <Metrik etiket="&quot;çocuklarla gezilecek yerler&quot;" deger="−%46" alt="2.400 → 1.300" ton="kotu" />
          <Metrik etiket="&quot;trambolin park&quot;" deger="−%33" alt="3.600 → 2.400" ton="kotu" />
          <Metrik etiket="&quot;doğum günü organizasyonu&quot;" deger="%0" alt="4.400 → 4.400 · düşmeyen tek segment" ton="iyi" />
        </MetrikSira>

        <Tablo
          baslik="Kategori sorguları — Ağustos → Eylül aylık arama hacmi (Türkiye)"
          basliklar={['Kelime', 'Ağu 2025', 'Eyl 2025', 'Değişim', 'Ağu 2024', 'Eyl 2024', 'Değişim']}
          saga={[1, 2, 3, 4, 5, 6]}
          satirlar={[
            [{ v: 'eğlence merkezi', kalin: true }, '49.500', '33.100', { v: '−%33', ton: 'kotu', kalin: true }, '49.500', '33.100', { v: '−%33', ton: 'kotu' }],
            ['oyun parkı', '14.800', '12.100', { v: '−%18', ton: 'kotu' }, '18.100', '14.800', { v: '−%18', ton: 'kotu' }],
            ['çocuk oyun alanı', '12.100', '9.900', { v: '−%18', ton: 'kotu' }, '12.100', '9.900', { v: '−%18', ton: 'kotu' }],
            ['trambolin park', '3.600', '2.400', { v: '−%33', ton: 'kotu' }, '2.900', '2.400', { v: '−%17', ton: 'kotu' }],
            ['çocuklarla gezilecek yerler', '2.400', '1.300', { v: '−%46', ton: 'kotu' }, '2.900', '1.600', { v: '−%45', ton: 'kotu' }],
            [{ v: 'doğum günü organizasyonu', kalin: true }, '4.400', '4.400', { v: '%0', ton: 'iyi', kalin: true }, '6.600', '5.400', { v: '−%18', ton: 'kotu' }],
          ]}
        />

        <Not tip="bilgi" baslik="Daralan ay, daralan hedefleme">
          Talep düşerken bütçeyi sabit tutmak, aynı sayıda kişiye daha pahalı ulaşmak demektir.
          Eylül'de mantıklı olan üç daraltma: <strong>(1) gün</strong> — hafta içi gündüz yerine Cuma akşamı-Pazar,
          <strong> (2) mesaj</strong> — "tatil/gün boyu eğlence" yerine okul sonrası ve hafta sonu,
          <strong> (3) segment</strong> — doğum günü organizasyonu ayrı kampanyaya çıkar, çünkü talebi düşmeyen tek başlık o.
        </Not>
      </Slayt>

      {/* ════════════ SLAYT 2 — KANIT ════════════ */}
      <Slayt
        no={2}
        etiket="Slayt 2 · Kanıt"
        accent="#0F766E"
        baslik="Ağustos bu hesabın rekor verimlilik ayıydı — ama tekrarlanabilir değil."
        spot="Temmuz'dan %17 daha az harcandı, iki kat sohbet geldi: sohbet maliyeti ₺966'dan ₺403'e indi. Buradaki iyileşmenin bir kısmı kurgudan, bir kısmı Ağustos'un okul tatilinin son ayı olmasından geliyor. Eylül'de aynı maliyeti vaat etmek dürüst olmaz."
        dipnot="Kaynak: canlı Meta Ads API (act_1492081179012995), Google Ads (6717327296), TikTok (7604848080818683921) üzerinden /api/group/hupalupa/monthly. Uyarı: Google'ın bu hesaptaki conversion_value'su PARA DEĞİL — dönüşüm değeri ile dönüşüm sayısı birebir aynı geliyor; oradan ROAS türetilmez."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="Ağustos sohbet" deger="709" alt="Temmuz: 357" ton="iyi" />
          <Metrik etiket="Ağustos sohbet maliyeti" deger="₺403" alt="Temmuz: ₺966" ton="iyi" />
          <Metrik etiket="Ağustos harcama" deger={tl(286044)} alt="Temmuz: ₺345.007" />
          <Metrik etiket="Verimlilik değişimi" deger="−%58" alt="sohbet başına maliyette" ton="iyi" />
        </MetrikSira>

        <Tablo
          baslik="HUPALUPA Eğlence — son 6 ay gerçekleşen"
          basliklar={['Ay', 'Meta', 'Google', 'TikTok', 'Toplam', 'Sohbet', 'Sohbet maliyeti']}
          saga={[1, 2, 3, 4, 5, 6]}
          satirlar={[
            ['Mart 2026', '₺193.539', { v: '—', ton: 'soluk' }, '₺17.352', '₺210.891', '649', '₺325'],
            ['Nisan 2026', '₺66.060', '₺123.405', '₺18.440', '₺207.905', '231', '₺900'],
            ['Mayıs 2026', '₺499.084', '₺127.235', '₺15.151', '₺641.471', '852', '₺753'],
            ['Haziran 2026', '₺391.797', '₺424.383', '₺137.836', '₺954.016', '369', { v: '₺2.585', ton: 'kotu' }],
            ['Temmuz 2026', '₺171.582', '₺130.193', '₺43.232', '₺345.007', '357', '₺966'],
            [{ v: 'Ağustos 2026', kalin: true }, '₺193.824', '₺70.608', '₺21.611', { v: '₺286.044', kalin: true }, { v: '709', ton: 'iyi', kalin: true }, { v: '₺403', ton: 'iyi', kalin: true }],
          ]}
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <Not tip="uyari" baslik="Aylar arası oynaklık çok yüksek — ortalamaya güvenmeyin">
            Sohbet maliyeti altı ayda <strong>₺325 ile ₺2.585</strong> arasında gezindi. Haziran'da ₺954.000
            harcanıp 369 sohbet alındı; Ağustos'ta ₺286.000 harcanıp 709 sohbet alındı. Bu hesapta sonucu
            belirleyen şey bütçe büyüklüğü değil, <strong>ayın kendisi ve kreatif</strong>. Eylül için
            temkinli plan maliyeti <strong>₺420-450</strong> alındı, Ağustos'un ₺403'ü değil.
          </Not>
          <Not tip="bilgi" baslik="Kreatif seçimini tıklamaya göre yapmayın">
            DM (Instagram Direct) reklam ailesinde tıklamanın mesaja dönme oranı kreatife göre
            <strong> %18,2 ile %55,3</strong> arasında oynuyor. En iyi kreatif — "Ara Tatil demek HUPALUPA demek"
            videosu — hem en yüksek dönüşle (%38,9) hem de ailedeki en düşük sohbet maliyetiyle çalıştı.
            En çok tık alan kreatif en çok mesaj getiren kreatif değil; Eylül'de kreatifler
            <strong> sohbet maliyetine göre</strong> seçilecek.
          </Not>
        </div>
      </Slayt>

      {/* ════════════ SLAYT 3 — TALEP ════════════ */}
      <Slayt
        no={3}
        etiket="Slayt 3 · Öneri"
        accent="#111827"
        baslik="Eylül 2026 önerimiz: ₺250.000 (−%12,6)"
        spot="Bu markada bütçe artışı istemiyoruz. Talep Eylül'de gerçekten geriliyor; azaltıp kalanı hafta sonuna ve doğum günü segmentine yığmak, aynı parayla daha fazla sohbet üretir. Serbest kalan ₺36.044, talebin arttığı Kixx'e aktarılıyor."
        dipnot="Sohbet projeksiyonu Ağustos'un gerçekleşen ₺403'ü değil, temkinli ₺420-450 aralığı üzerinden kurulmuştur; sebebi Eylül'de hafta içi trafiğinin bitmesi ve kategori talebinin −%33 gerilemesi."
      >
        <MetrikSira kolon={4}>
          <Metrik etiket="Ağustos gerçekleşen" deger={tl(286044)} alt="Meta + Google + TikTok" />
          <Metrik etiket="Eylül önerisi" deger={tl(250000)} alt="−₺36.044 · −%12,6" ton="kotu" />
          <Metrik etiket="Beklenen sohbet" deger="550 – 595" alt="₺420-450 / sohbet" />
          <Metrik etiket="Hafta sonuna ayrılan pay" deger="%60" alt="Cuma 16:00 – Pazar 23:59" ton="iyi" />
        </MetrikSira>

        <div>
          <div className="text-[11px] font-semibold text-gray-700 mb-2.5">Mecra dağılımı</div>
          <Dagilim
            toplam={250000}
            kalemler={[
              { ad: 'Meta (DM + Etkileşim)', tutar: 165000, renk: '#0F766E', not: 'sohbet motoru' },
              { ad: 'Google Ads', tutar: 60000, renk: '#1D4ED8', not: 'yerel arama + marka' },
              { ad: 'TikTok', tutar: 25000, renk: '#111827', not: 'ucuz erişim, hafta sonu' },
            ]}
          />
        </div>

        <Tablo
          baslik="Ağustos gerçekleşen → Eylül plan"
          basliklar={['Mecra', 'Ağustos', 'Eylül planı', 'Değişim', 'Eylül\'de ne değişiyor']}
          saga={[1, 2, 3]}
          sarmala={[4]}
          satirlar={[
            ['Meta Ads', '₺193.824', { v: '₺165.000', kalin: true }, { v: '−%15', ton: 'kotu' }, 'DM kurgusu korunuyor, yayın hafta sonuna yığılıyor. Doğum günü ayrı kampanya.'],
            ['Google Ads', '₺70.608', { v: '₺60.000', kalin: true }, { v: '−%15', ton: 'kotu' }, 'Kategori sorguları düşüyor; bütçe marka ve yerel sorgularda tutuluyor.'],
            ['TikTok', '₺21.611', { v: '₺25.000', kalin: true }, { v: '+%16', ton: 'iyi' }, 'Tıklama maliyeti Ağustos\'ta ₺0,65\'e indi — daralan ayda en ucuz erişim burada.'],
            [{ v: 'Toplam' }, '₺286.044', { v: '₺250.000' }, { v: '−%13', ton: 'kotu' }, ''],
          ]}
          vurguSonSatir
        />

        <Not tip="bilgi" baslik="Bu azaltma geri alınabilir">
          Eylül'ün ilk iki haftasında sohbet maliyeti <strong>₺400'ün altında</strong> kalırsa, düşüşün kurguya
          değil takvime bağlı olmadığı anlaşılır ve ikinci yarı için ₺40.000 ek bütçe talep edilir. Ekim'de
          ara tatil yaklaştığı için bütçe zaten yukarı dönecek — bu öneri Eylül'e özeldir, kalıcı bir kısıntı değil.
        </Not>

        <GrupSeridi vurgu="HUPALUPA Eğlence" />
      </Slayt>
    </Deck>
  );
}
